<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="bookmark-dialog"
    >
      <v-card>
        <v-row class="no-gutters mx-0 my-0" style="margin-top: 0 !important">
          <v-col class="col-12 image-container">
            <v-icon @click="dialog = false" class="close-dialog"
              >mdi-close</v-icon
            >
            <span
              v-if="bookmarks.items[imageShowIndex]"
              class="full-name"
              @click="
                visitOnlyProfile(bookmarks.items[imageShowIndex].personId)
              "
              >{{ bookmarks.items[imageShowIndex].deceasedFullName }}</span
            >
            <div class="action-dialog d-flex flex-column align-center">
              <v-icon
                @click="visitProfile(bookmarks.items[imageShowIndex])"
                class="mr-1 cursor-pointer display-1 mt-3 white--text"
                >mdi-open-in-app</v-icon
              >
              <v-icon
                @click="deleteBookmark(bookmarks.items[imageShowIndex])"
                class="mr-1 cursor-pointer display-1 mt-3 orange--text"
                >mdi-bookmark</v-icon
              >
            </div>
            <v-icon
              @click="leftImage()"
              class="back-image"
              v-if="imageShowIndex != 0"
              >mdi-chevron-left</v-icon
            >
            <v-icon
              v-if="
                bookmarks.items && imageShowIndex != bookmarks.items.length - 1
              "
              @click="rightImage()"
              class="next-image"
              >mdi-chevron-right</v-icon
            >
            <div v-if="bookmarks && bookmarks.items && bookmarks.items.length">
              <img
                v-if="bookmarks.items[imageShowIndex].type == '1'"
                :src="bookmarks.items[imageShowIndex].url"
                alt="Bookmark Image"
                :lazy-src="require('../assets/images/lazy-loading.png')"
              />
              <video
                v-else
                controls
                :key="bookmarks.items[imageShowIndex].url"
                style="width: 100%"
                controlsList="nodownload"
              >
                <source
                  :src="bookmarks.items[imageShowIndex].url"
                  type="video/mp4"
                />
                <source
                  :src="bookmarks.items[imageShowIndex].url"
                  type="video/webm"
                />
                <source
                  :src="bookmarks.items[imageShowIndex].url"
                  type="video/ogg"
                />
                <source
                  :src="bookmarks.items[imageShowIndex].url"
                  type="video/quicktime"
                />
                <source
                  :src="bookmarks.items[imageShowIndex].url"
                  type="video/x-msvideo"
                />
                <source
                  :src="bookmarks.items[imageShowIndex].url"
                  type="video/x-matroska"
                />
                Your browser does not support the video tag.
              </video>
            </div>
            <div v-else style="width: 80%">
              <v-skeleton-loader type="image, image"></v-skeleton-loader>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-row class="page-title-container">
      <v-col class="col-12">
        <h2 class="page-title">{{ lang.menuLinks.bookmarks }}</h2>
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col
        v-for="(bookmark, index) in bookmarks.items"
        :key="index"
        cols="4"
        sm="3"
        md="2"
        lg="2"
        class="p-05"
      >
        <div class="entity-container" v-if="bookmark.type == '1'">
          <v-img
            :alt="'Bookmark ' + bookmark.id"
            :lazy-src="require('../assets/images/lazy-loading.png')"
            :src="bookmark.url"
            aspect-ratio="1"
            @click="preview(index)"
            style="cursor: pointer"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </div>
        <div class="entity-container" v-else style="cursor: pointer">
          <video
            style="width: 100%"
            @click="preview(index)"
            v-if="bookmark.url"
            :key="bookmark.url"
            controlsList="nodownload"
          >
            <source :src="bookmark.url" type="video/mp4" />
            <source :src="bookmark.url" type="video/webm" />
            <source :src="bookmark.url" type="video/ogg" />
            <source :src="bookmark.url" type="video/quicktime" />
            <source :src="bookmark.url" type="video/x-msvideo" />
            <source :src="bookmark.url" type="video/x-matroska" />
            Your browser does not support the video tag.
          </video>
        </div>
      </v-col>
      <v-col cols="12">
        <v-pagination
          v-if="bookmarks.items && bookmarks.items.length"
          class="mt-4"
          v-model="listPayload.pageIndex"
          :length="bookmarksCount"
          :total-visible="6"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="getBookmarks()"
        ></v-pagination>
      </v-col>
    </v-row>
    <v-row v-if="!bookmarks.items.length">
      <v-col class="col-12">
        <NoResult
          :show="!bookmarks.items.length"
          class="mt-0"
          :title="lang.noResult.bookmarks"
          :button="{ link: '/MyMemories', text: lang.noResult.bookmarkBtn }"
        ></NoResult>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NoResult from "../components/noResult";
export default {
  name: "Bookmarks",
  data() {
    return {
      imageShowIndex: 0,
      imageComment: "",
      dialog: false,
      listPayload: {
        pageIndex: 1,
        limit: 18,
        userId: null,
      },
    };
  },
  components: {
    NoResult,
  },
  computed: {
    ...mapGetters("user", ["currentUser"]),
    ...mapGetters("general", ["bookmarks"]),
    lang() {
      return this.$store.state.langObj || {};
    },
    bookmarksCount() {
      return this.bookmarks.totalPages;
    },
  },
  methods: {
    visitOnlyProfile(id) {
      this.$router.push({ name: "Profile", params: { id: id } });
    },
    visitProfile(bio) {
      this.$router.push({
        name: "Profile",
        params: { id: bio.personId },
        query: { id: bio.entityId, type: bio.type },
      });
    },
    preview(index) {
      this.imageShowIndex = index;
      this.dialog = true;
      var entity = this.bookmarks.items[this.imageShowIndex];
      this.$router.push({ query: { id: entity.entityId } });
    },
    leftImage() {
      this.imageShowIndex = this.imageShowIndex - 1;
      var entity = this.bookmarks.items[this.imageShowIndex];
      this.$router.push({ query: { id: entity.entityId } });
    },
    rightImage() {
      this.imageShowIndex = this.imageShowIndex + 1;
      var entity = this.bookmarks.items[this.imageShowIndex];
      this.$router.push({ query: { id: entity.entityId } });
    },
    deleteBookmark(bookmark) {
      this.$store
        .dispatch("general/deleteBookmark", { id: bookmark.id })
        .then(() => {
          this.listPayload.pageIndex = 1;
          this.$store
            .dispatch("general/getBookmarks", this.listPayload)
            .then(() => {
              if (this.bookmarks.items.length == 0) {
                this.dialog = false;
              } else {
                this.imageShowIndex = 0;
              }
            });
        });
    },
    getBookmarks(resetPage = false) {
      if (resetPage) {
        this.listPayload.pageIndex = 1;
      }
      this.$store.dispatch("general/getBookmarks", this.listPayload);
    },
  },
  mounted() {
    document.title = "Good Casper - Bookmarks";
    this.listPayload.userId = this.currentUser.id;

    this.$store.dispatch("general/getBookmarks", this.listPayload).then(() => {
      if (this.$route.query.id) {
        var index = this.bookmarks.items.findIndex(
          (x) => x.entityId == this.$route.query.id
        );
        if (index != -1) {
          this.imageShowIndex = index;
          this.dialog = true;
        }
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.p-05 {
  padding: 1px;
}
.v-dialog {
  overflow-x: hidden !important;
}
.full-name {
  text-decoration: underline;
  color: white;
  font-size: 20px;
  position: absolute;
  top: 0;
  left: 40px;
  padding: 10px;
  margin-left: 20px;
  cursor: pointer;
  text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
}
.entity-container {
  display: flex;
  align-content: center;
  justify-content: center;
  height: 100%;
}
.image-container {
  position: relative;
  background: #1c1e21;
  min-height: calc(100vh);
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    max-width: 100vw;
    max-height: 100vh;
    margin: auto auto;
  }
  video {
    max-width: 100vw;
    max-height: 100vh;
    margin: auto auto;
  }
  .action-dialog {
    position: absolute;
    top: 0;
    right: 0;
    color: #fff;
    padding: 0 15px 5px 15px;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    z-index: 5;
    button {
      text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    }
  }
  .close-dialog {
    position: absolute;
    top: 0;
    left: 0;
    color: #fff;
    padding: 15px;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    &:hover {
      background: rgb(27 27 27 / 80%);
    }
  }
  .next-image {
    position: absolute;
    position: absolute;
    top: 49%;
    right: 10px;
    z-index: 5;
    color: #fff;
    padding: 15px 15px;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    &:hover {
      background: rgb(27 27 27 / 80%);
    }
    &::after {
      background: transparent !important;
    }
  }
  .back-image {
    position: absolute;
    position: absolute;
    top: 49%;
    left: 0;
    z-index: 5;
    color: #fff;
    padding: 15px 15px;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    &:hover {
      background: rgb(27 27 27 / 80%);
    }
    &::after {
      background: transparent !important;
    }
  }
}

@media only screen and (max-width: 960px) {
  .image-container {
    img, video {
      max-width: 100vw;
      max-height: calc(100vh - 10px);
      margin: auto auto;
    }
  }
}
</style>